import React from "react";
import {observer} from "mobx-react-lite";
import {Alert, CircularProgress, Grid} from "@mui/material";
import {useStores} from "../../../stores";
import {environment} from "../../../env";
import {SupplierNormalizationState} from "./SupplierNormalization.classes";

export const SupplierNormalizationApplyingResultsStep: React.FC = observer(() => {
    const {supplierNormalizationStore} = useStores();
    return (
        <section className="page-item step applying-results-step">
            <Grid container justifyContent="center">
                <Grid>
                    {supplierNormalizationStore.state === SupplierNormalizationState.APPLYING
                        ? <Alert
                            severity="info"
                            icon={false}
                            // icon={<HourglassEmpty fontSize="inherit" />}
                            onClick={() => environment.isTest && supplierNormalizationStore.goToState(SupplierNormalizationState.DONE)}>
                            <span>
                                <CircularProgress size={15}/>
                            </span>
                            Applying results, please wait
                        </Alert>
                        : <Alert severity="success">
                            Results applied successfully
                        </Alert>
                    }
                </Grid>
            </Grid>
        </section>
    );
})
